import React from 'react';
import {MasterLayout} from 'components/layouts';
import {PhuyenBusiness} from 'components/business/phuyen-business';
import title from 'constants/TitlePages.js';

class PhuyenBusinessPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.PhuyenBusinessPage;
  }

  render() {
    return (
      <MasterLayout>
        <PhuyenBusiness/>
      </MasterLayout>
    );
  }
}

export default PhuyenBusinessPage;



// WEBPACK FOOTER //
// ./pages/businesses/PhuyenBusinessPage.jsx